import React from 'react';
import classnames from 'classnames';
import { materialTypeOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const MaterialType = (props) => {
  const name = 'material_type';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
    locked,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('material-type', className)}
      disabled={disabled}
      locked={locked} />
  );
};

MaterialType.defaultProps = {
  label: Spree.translations.parameters.material_type,
  options: materialTypeOptions,
  name: 'material_type',
  tooltip: Spree.helpForParameters.material_type,
};

export default MaterialType;
